// Time tracking utility functions for employee dashboard

import dayjs from 'lib/dayjs';

export const getCurrentDateTime = () => {
  return dayjs().toISOString();
};

export const formatTime = (dateTimeString) => {
  if (!dateTimeString) return '--:--';
  return new Date(dateTimeString)?.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const formatDate = (dateString) => {
  if (!dateString) return 'Date not available';

  try {
    const date = new Date(dateString);
    if (isNaN(date?.getTime())) {
      return 'Invalid date';
    }
    return date?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Date not available';
  }
};

export const calculateWorkingHours = (checkIn, checkOut) => {
  if (!checkIn || !checkOut) return 0;
  const start = new Date(checkIn);
  const end = new Date(checkOut);
  const diff = end - start;
  return diff / (1000 * 60 * 60); // Convert to hours
};

export const formatHoursMinutes = (hours) => {
  if (!hours || hours < 0) return '0h 0m';

  const totalMinutes = Math.floor(hours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  return `${h}h ${m}m`;
};
export const formatTimeFromDecimal = (decimalHours) => {
  if (decimalHours == 0) {
    return '';
  }

  const hours = Math.floor(decimalHours); // Get the whole number of hours
  const minutes = Math.round((decimalHours - hours) * 60); // Convert the decimal part to minutes

  if (hours && minutes) {
    return `${hours}h ${minutes}m`;
  } else if (hours) {
    return `${hours}h`;
  } else if (minutes) {
    return `${minutes}m`;
  }
};
export const formatTimeHHMMSS = (hours) => {
  if (!hours || hours < 0) return '00:00:00';

  const totalSeconds = Math.round(hours * 3600);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  return `${String(h)?.padStart(2, '0')}:${String(m)?.padStart(
    2,
    '0',
  )}:${String(s)?.padStart(2, '0')}`;
};
